/**
 * §2.8a / §2.8f (E37) — the languages the platform ships, as one list.
 *
 * Here rather than in `portal-kit` because three things read it and only two
 * of them are browsers: both consoles offer it in a picker, and `api-core`
 * refuses a tag that is not on it. A list the API does not check is one the
 * database fills with `de` the first time somebody edits a request by hand,
 * and a picker whose native `<select>` is then handed a value it does not
 * offer shows the first option instead — which reads as "English" to somebody
 * who chose German and is a lie about what was saved.
 *
 * Each is named in its own language. Somebody who cannot read the current one
 * cannot find "Portuguese" in a list written in English, which is the one
 * moment where that matters most.
 *
 * Three, not six. The AffDice Affiliate offered German, French and Italian in a
 * dropdown and had translated none of them, so an affiliate who picked one
 * read English and concluded the platform was broken — which is the correct
 * conclusion to draw from a control that does nothing. A language belongs in
 * this list when it has a catalogue, and joins it in the same commit.
 */
export const SHIPPED_LOCALES = [
    { value: 'en', label: 'English' },
    { value: 'pt-BR', label: 'Português (Brasil)' },
    { value: 'es', label: 'Español' },
];
/** The tags alone, for a refusal message or a `details.offered` list. */
export const SHIPPED_LOCALE_TAGS = SHIPPED_LOCALES.map((l) => l.value);
/**
 * A BCP 47 language tag, in the shape the platform accepts everywhere else:
 * `en`, `pt-BR`. Same regex as `affiliate_identities.locale`'s CHECK (0020)
 * and `users.locale`'s (0150).
 */
export const LOCALE_TAG = /^[a-z]{2}(-[A-Z]{2})?$/;
export function isShippedLocale(tag) {
    return SHIPPED_LOCALE_TAGS.includes(tag);
}
//# sourceMappingURL=locales.js.map